module.exports = __webpack_public_path__ + "media/images/d2l_logo_square_36-cfe50d6b5a9dfa33eb675c1cfb6d0921.png";